module.exports = __webpack_public_path__ + "static/media/light7.4fd6d6f6.png";